import React, { useEffect, useState } from 'react'
import {
  Box,
  CircularProgress,
  FormLabel,
  Grid,
  Modal,
  styled,
  Typography,
  Button,
  DialogActions,
  Fade,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from '@mui/material'
import { BorderButtonPurple, CustomButton } from '../buttons'
import lightTheme from '../../styles/theme/lightTheme'
import '../../styles/components/_box.scss'
import '../../styles/components/_grids.scss'
import '../../styles/components/_inputs.scss'
import { SelectInputBasic, TextInput } from '../inputs'
import Api from '../../services/api.service'
import { handlingErrors } from '../../utils'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import * as yup from 'yup'
import { phoneRegExp } from '../../config'
import { useDispatch } from 'react-redux'
import { userLogout } from '../../store/slices/userAuthReducer'
import TextareaInputClassic from '../inputs/TextareaInputClassic'
import { useTranslation } from 'react-i18next'
import { ROLE_ENTREPRISE } from '../../data'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import OutlineButton from '../buttons/OutlineButton'
import GradientButton from '../buttons/GradientButton'

const ModalContainer = styled(Box)(({ theme }) => ({
  width: 'calc(100% - 32px)',
  maxWidth: 800,
  minHeight: 400,
  maxHeight: '90vh',
  backgroundColor: '#FFFFFF',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '16px',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',

  '&:focus-visible': {
    outline: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    width: 800,
    padding: '20px 40px',
  },
}))

const BoxContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}))

const parSchema = yup.object({
  //besoin: yup.string().required('Merci de renseigner ce champ.'),
})

const EditBesoin = ({ open, onClose, onSave, openDelete, id, role }) => {
  const { t } = useTranslation()

  const proSchema = yup.object({
    prenom: yup.string().required(t('errorMessage.required')),
    nom: yup.string().required(t('errorMessage.required')),
    email: yup
      .string()
      .email(t('errorMessage.emailValid'))
      .required(t('errorMessage.required')),
    telephone: yup
      .string()
      .required(t('errorMessage.required'))
      .matches(phoneRegExp, t('errorMessage.phone'))
      .nullable(),
    raisonSocial: yup.string().required(t('errorMessage.required')),
    /*langues: yup.string().required("Merci de renseigner ce champ."),
    dateNaissance: yup.string().required("Merci de renseigner ce champ."),
    statusMarital: yup.string().required("Merci de renseigner ce champ."),*/
  })

  const [loadingInfos, setLoadingInfos] = useState(true)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  //const [fonctions, setFonctions] = useState([])
  const [fonctionSelect, setFonctionSelect] = useState('')
  const [besoin, setBesoin] = useState('')
  const [snapShot, setSnapShot] = useState(null)
  const { register, handleSubmit, reset } = useForm({
    resolver: yupResolver(role === ROLE_ENTREPRISE ? proSchema : parSchema),
  })

  useEffect(() => {
    fetchData()
  }, [id, dispatch, reset])

  const fetchData = async () => {
    setLoadingInfos(true)
    try {
      let result = await Api.user.detail(id)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        console.log('erreur')
      }

      if (handling.ok) {
        const res = handling.data
        setSnapShot(res)
        setBesoin(res.candidat.besoin)
        reset(res)
        setLoadingInfos(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleFonctionSelect = (event) => {
    const inputValue = event.target.value
    setFonctionSelect(inputValue)
  }

  const onSubmit = async (data) => {
    setLoading(true)

    //return

    const {
      admin,
      candidat,
      userOffres,
      date,
      entreprise,
      lang,
      offre,
      parent,
      password,
      status,
      ...rest
    } = data
    try {
      const result = await Api.candidate.edit(candidat.id, {
        besoin: candidat.besoin,
      })
      const handling = handlingErrors(result)

      if (handling.status === 401) {
        dispatch(userLogout())
        return
      }

      if (handling.ok) {
        //const res = handling.data
        setLoading(false)
        onSave()
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fullScreen = useMediaQuery(lightTheme.breakpoints.down('sm'))
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      scroll={'paper'}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '16px',
          p: fullScreen ? 0 : '8px',
          m: fullScreen ? 0 : undefined,
          maxHeight: fullScreen ? '100%' : '90vh',
          ...(fullScreen && {
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
          px: { xs: 2, sm: 3 },
          py: { xs: 1.5, sm: 2 },
          pb: 2,
          flexShrink: 0,
          borderBottom: '1px solid rgba(229, 231, 235, 0.8)',
          backgroundColor: 'rgba(249, 250, 251, 0.5)',
        }}
      >
        <Typography
          variant={fullScreen ? 'subtitle1' : 'h6'}
          sx={{ fontWeight: 600, color: '#1f2937', pr: 1, lineHeight: 1.3 }}
        >
          {role === ROLE_ENTREPRISE ? (
            <>{t('box.title.editJob')}</>
          ) : (
            <>{t('box.title.searchCandidate')}</>
          )}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#6b7280',
            '&:hover': {
              backgroundColor: 'rgba(107, 114, 128, 0.1)',
              color: '#374151',
            },
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 1, pt: '8px !important' }}>
        {loadingInfos ? (
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <Box
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%',
            }}
          >
            {role === ROLE_ENTREPRISE && (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                  gap: 2,
                  p: 2,
                  borderRadius: '18px',
                  border: '1px solid rgba(229, 231, 235, 0.9)',
                  backgroundColor: 'rgba(249, 250, 251, 0.9)',
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <FormLabel className={'labelForm'}>
                    {t('box.companyName')}
                  </FormLabel>
                  <TextInput
                    placeholder={t('box.companyName')}
                    type={'text'}
                    register={{ ...register('entreprise.raisonSocial') }}
                    width="100%"
                  />
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <FormLabel className={'labelForm'}>
                    {t('contact.function')}
                  </FormLabel>
                  <SelectInputBasic
                    items={[]}
                    value={fonctionSelect}
                    handleChange={handleFonctionSelect}
                  />
                </Box>
              </Box>
            )}

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                p: 2,
                borderRadius: '18px',
                border: '1px solid rgba(229, 231, 235, 0.9)',
                backgroundColor: '#ffffff',
              }}
            >
              <FormLabel className={'labelForm'}>
                {t('contact.need')}
              </FormLabel>
              <TextareaInputClassic
                type={'border'}
                width={'100%'}
                register={{ ...register('candidat.besoin') }}
                sx={{ minHeight: 170 }}
              />
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 2, sm: 3 },
          gap: 2,
          justifyContent: 'center',
          backgroundColor: 'rgba(249, 250, 251, 0.8)',
          borderTop: '1px solid rgba(229, 231, 235, 0.8)',
          flexDirection: { xs: 'column', sm: 'row' },
          flexShrink: 0,
          flexWrap: 'wrap',
          '& > *': {
            width: { xs: '100%', sm: 'auto' },
            m: 0,
          },
        }}
      >
        <OutlineButton onClick={onClose} fullWidth={fullScreen}>{t('button.cancel')}</OutlineButton>

        <GradientButton onClick={handleSubmit(onSubmit)} fullWidth={fullScreen}>
          {loading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1, color: 'white' }} />
              {t('profile.saving')}
            </>
          ) : (
            t('button.save')
          )}
        </GradientButton>
      </DialogActions>
      {/*</Box>*/}
    </Dialog>
  )
}

export default EditBesoin
